
export interface PriceItem {
  productId: string;
  productName: string;
  msrp: string;
  [key: string]: string; // Add index signature to match PriceData interface
}

export const updatedPriceData: PriceItem[] = [
  {
    productId: "VPX-TC1-PRO",
    productName: "VPX TC1 Pro Transceiver",
    msrp: "1199.00"
  },
  {
    productId: "VPX-TC1-LT",
    productName: "VPX TC1 Lite Transceiver",
    msrp: "899.00"
  },
  {
    productId: "VPX-UC1-ULTRA",
    productName: "VPX UC1 Ultra Control Processor",
    msrp: "1499.00"
  },
  {
    productId: "IPX-TC3A-WP3-PRO",
    productName: "IPX TC3A Wall Plate Transceiver Pro",
    msrp: "2499.00"
  },
  {
    productId: "IPX-UC1-ULTRA",
    productName: "IPX UC1 Ultra 10G Control Processor",
    msrp: "2999.00"
  },
  {
    productId: "RXC-BT1",
    productName: "ReAX Control Button Panel",
    msrp: "799.00"
  },
  {
    productId: "RXC-CE1",
    productName: "ReAX Control Engine",
    msrp: "1299.00"
  },
  {
    productId: "RXC-TP7",
    productName: "ReAX 7\" Touch Panel",
    msrp: "1899.00"
  },
  {
    productId: "ABX-CM1",
    productName: "Audio Box Core Module",
    msrp: "699.00"
  },
  {
    productId: "ABX-AMP100",
    productName: "Audio Box 100W Amplifier",
    msrp: "599.00"
  },
  {
    productId: "DXB-8",
    productName: "8x8 HDMI Matrix Switcher",
    msrp: "2499.00"
  },
  {
    productId: "HT-TC1",
    productName: "HDBaseT Transmitter",
    msrp: "499.00"
  },
  {
    productId: "HT-RC1",
    productName: "HDBaseT Receiver",
    msrp: "499.00"
  },
  {
    productId: "IPB-4K-TX",
    productName: "IPBaseT 4K Transmitter",
    msrp: "1299.00"
  },
  {
    productId: "IPB-4K-RX",
    productName: "IPBaseT 4K Receiver",
    msrp: "1299.00"
  }
];
